module.exports = __webpack_public_path__ + "media/assets/images/cloudy_later_will_rain-d528df59344e3a51cf250ba07fc02baf.png";